import React from "react";
import Container from "./container";
import { cn } from "../lib/helpers";
import PartnerCard from "./partner-card";

import * as styles from "../styles/components/partners-grid.module.css";

const PartnersGrid = (props) => {

  const {
    heading,
    partnerItems
  } = props;

  return (
    <div className={styles.root}>
      <Container>
        {heading && <h2 className={cn("h3", styles.heading)}>{heading}</h2>}
        {(partnerItems && partnerItems.length) ?        
       <div className="grid">
        <div className="col-12">
          <div className={cn("grid", styles.items)}>
            {partnerItems.map((partnerItem) => (
              <div key={partnerItem.slug.current} className={cn("col-12 col-md-4 col-lg-3", styles.item)}>
                <PartnerCard partnerItem={{title: partnerItem.title, slug: partnerItem.slug.current, description: partnerItem.description, logo: partnerItem.logo}} title="h2" />
              </div>
            ))}
          </div>
        </div>
      </div>
        : null
      }
      </Container>

    </div>
  );
}

export default PartnersGrid;